import React, { useEffect, useState } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Form } from "react-bootstrap";
import "./Header.styles.css";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import MobileMenu from "../../components/MobileMenu/MobileMenu";
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userLogIn, isUserLogedIn } from "../../services/auth";
import { useNavigate } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';
import { nextWednesday } from 'date-fns/esm';
import { forEach } from 'lodash';
import Cart from '../../components_CO/Mycart/Cart';
import ActiveCatalogue from '../../components_CO/ActiveCatalogue/ActiveCatalogue'
import { useSelector, useDispatch } from 'react-redux'

const Header = ({ firstProp, secondProp, confirmPage }) => {
  const navigate = useNavigate();
  const compare = useSelector(state => state.compare);
	const dispatch = useDispatch();
  var key = 0;
  const [logedIn, setLogedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  toast.configure();

  const [headerList, setHeaderList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [activeC, setActiveC] = useState(false);

  const getBrands = async () => {
    try {
      await Axios.get('/sysvar/brandList')
        .then(function (response) {
          if (response.data && response.data.brandList) {
            var brandList = response.data.brandList;
            var actualLength = Math.floor(brandList.length / 6);
            var needMore = 6 - (brandList.length - (actualLength * 6));
            for (var i = 0; i < needMore; i++) {
              brandList.push({ "grp": { "groupid": "brand", "varid": "1001", "varname": " ", "varvalue": 1001, "paramfield": "brandList", "paramvalue": "", "url": " / " }, "subgrp": null });
            }
            if (brandList.length > 0) {
              brandList.forEach(element => {
                // element.grp.newUrl="/brand?name="+element.grp.url?.split("/")[1]+"&baseName="+element.grp.varname;
                element.grp.newUrl = "/brand?name=" + element.grp.url?.split("/")[1];
              });
              setBrandList(brandList);
            }
            else {
              setBrandList([]);
            }
          }
        })
        .catch(function (error) {
          setBrandList([]);
        });
    } catch (error) {
      console.error(error)
    }

  };

  const getHeaders = async () => {
    try {
      await Axios.get('/sysvar/ProductType')
        .then(function (response) {
          if (response.data && response.data.ProductType) {
            if (response.data.ProductType.length > 0) {
              response.data.ProductType.forEach(element => {
                element.grp.newUrl = "/category?name=" + element.grp.url?.split("/")[1];
                if (element?.subgrp && element.subgrp.length > 0) {
                  element.subgrp.forEach(element2 => {
                    element2.grp.newUrl = "/category?name=" + element2.grp.url?.split("/")[1];
                    if (element2.subgrp?.length > 0) {
                      element2.subgrp.forEach(element3 => {
                        // element3.grp.newUrl="/category?name="+element3.grp.url?.split("/")[1]+"&baseName="+element3.grp.varname;
                        element3.grp.newUrl = "/category?name=" + element3.grp.url?.split("/")[1];
                      })
                    }
                  })
                }
              });
              setHeaderList(response.data.ProductType);
            }
            else {
              setHeaderList([]);
            }
          }
        })
        .catch(function (error) {
          setHeaderList([]);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getHeaders();
    getBrands();
    setLogedIn(AuthVerify.isUserLogedIn());
    return () => {
      // Cleanup function
      // Cancel any outstanding network requests or subscriptions here
    };
  }, [])

  useEffect(async () => {
    const user = AuthVerify.getUser();
    setUserInfo(user);
    if (user && user.role) {
      //   api/account/costcenter
      // if(user.applycorpsetting){
      await Axios.get(`/account/costcenter`)
        .then(async (data) => {
          var details = [];
          details.activeCC = {};
          details.activeC = {};
          if (data.data?.data?.length > 0) {
            data.data.data.map(item => {
              if (item.active) {
                item.catalogs.map((item) => {
                  if (item.active) {
                    setActiveC({
                      cname: item.catalogname,
                      cnum: item.catalognum
                    });
                  }
                })
              }
            })
          }
        })
      // }
    }
  }, [])

  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    window.mobileMenuView();
  };

  return (
    <>
      <MobileMenu headerList={headerList} brand={brandList} collapsed={collapsed} activeC={activeC} />
      <nav>
        <div className="container">
          <div className="mm-toggle-wrap">
            <div className="mm-toggle">
              <i className="fa fa-align-justify" id='mobileMenuBtn' onClick={toggleCollapsed}></i>
              <span className="mm-label">Menu</span>
            </div>
          </div>
          <div className="nav-inner-co">

            <ul id="nav" className="hidden-xs" style={{ textAlign: "right" }}>
              <li className="drop-menu">
                <Link className="level-top active" to="/">
                  <p>Home</p>
                </Link>
              </li>

              <li className="parentCustom">
                <Link className="level-top" to="/category?name=all" >

                  <p>{"Categories"}</p>
                </Link>

                {headerList.length > 0 &&
                  // <ul className="childCustom" style={{left:'25%'}}>
                  <ul className="childCustom" style={{ top: '20px' }}>
                    {headerList?.map((menu) => (
                      <>
                        {
                          // menu?.subgrp?.length > 0 && 
                          <li className="parentCustom" key={key++}>
                            <Link to={menu.grp?.newUrl || '#'}><span className='parentName' style={{ display: 'table-cell !important' }}>{menu.grp.varname}</span> {menu?.subgrp && <span className="expandCustom">&raquo;</span>}</Link>
                            <ul className="childCustom" style={{ opacity: 0 }}>
                              {menu?.subgrp && menu?.subgrp.map((subMenu) => (
                                // <li style={{textAlign: 'left',fontWeight:'bold !important', borderBottom: '2px solid black', pointerEvents:'none'}}><a href="#">{subMenu.grp.varname}</a></li>
                                <>{subMenu.subgrp?.length > 0 ?
                                  <>
                                    <li className="parentCustom" key={key++}>
                                      <Link to={subMenu.grp?.newUrl || '#'}><span className='parentName'>{subMenu.grp.varname}</span> <span className="expandCustom">&raquo;</span></Link>
                                      <ul className="childCustom" style={{ opacity: 0, top: 0, maxHeight: '450px', overflow: 'auto' }}>
                                        {subMenu?.subgrp?.map((subMenu2) => (
                                          <li key={key++}><Link to={subMenu2.grp?.newUrl || '#'}>{subMenu2.grp.varname}</Link></li>
                                        ))
                                        }
                                      </ul>
                                    </li>
                                  </> :
                                  <><li key={key++}><Link to={subMenu.grp?.newUrl || '#'}>{subMenu.grp.varname}</Link></li></>
                                }</>
                              ))}
                            </ul>
                          </li>
                        }
                      </>
                    ))}
                  </ul>
                }
              </li>
              {activeC && <>
                <li className="mega-menu">
                  <Link className="level-top" to="/category?name=all" >
                    <p>{"My Catalog"}</p>
                  </Link>
                  {
                    1 < 0 && brandList.length > 0 ?
                      <div className="jtv-menu-block-wrapper">
                        <div className="jtv-menu-block-wrapper2">
                          <div className="nav-block jtv-nav-block-center">

                            <ul className="level0 level_">
                              {brandList.map((brand, id) => (
                                <li key={id} className="parent item" style={{ width: "" }} >
                                  <Link to={brand?.grp?.newUrl}>
                                    <span>{brand?.grp?.varname}</span>
                                  </Link>
                                </li>
                                // {brandList.length==id-1 &&

                                // }
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                      :
                      <></>
                  }
                </li>
              </>}
              <li>
                <Link className="level-top" to="/contactus">
                  <p>Contact us</p>
                </Link>
              </li>
              {/* <li>
                <Link className="level-top" to="/helpdesk">
                  <i
                    className="icon-briefcase icons"
                    style={{ fontSize: "x-large" }}
                  ></i>
                  <p>Help Desk</p>
                </Link>
              </li> */}
              <li>
                <Link className="level-top" to="/faqs">
                  <p>FAQs</p>
                </Link>
              </li>
              {/* <li>
                <Link className="level-top" to="/send-us-message">
                  <i
                    className="fa fa-paper-plane"
                    style={{ fontSize: "x-large" }}
                  ></i>
                  <p>Send us Message</p>
                </Link>
              </li> */}

              {logedIn ?
                <li className="parentCustom">
                  <Link className="level-top" to="/my-account">
                    <p>My Account</p>
                  </Link>
                  <ul className="childCustom" style={{ top: '20px', border: 'none', background: 'var(--navBG)' }}>
                    <li style={{ fontWeight: "500" }}>Username : {userInfo?.username}</li>
                  </ul>
                </li>
                :
                <li>
                  <Link to="/signup" className="level-top">
                    <p>Sign up/Login</p>
                  </Link>
                </li>
              }
            </ul>
          </div>
        </div>
      </nav>
      {/* <ActiveCatalogue reducer={compare} dispatch={dispatch}/> */}
      <Cart confirmPage={confirmPage} />
    </>
  );
};

export default Header;
